module.exports = __webpack_public_path__ + "static/media/StepBoxTriangle.4f81c5ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-screen/StepBoxTriangle.svg
// module id = 503
// module chunks = 0